import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { supabase } from '@/integrations/supabase/client';

// Import translations
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import nlTranslations from './locales/nl.json';
import esTranslations from './locales/es.json';
import deTranslations from './locales/de.json';

// Import help translations
import helpEnTranslations from './locales/help-en.json';
import helpFrTranslations from './locales/help-fr.json';
import helpNlTranslations from './locales/help-nl.json';

// Initialize i18next
const initI18n = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          translation: { ...enTranslations, ...helpEnTranslations }
        },
        fr: {
          translation: { ...frTranslations, ...helpFrTranslations }
        },
        nl: {
          translation: { ...nlTranslations, ...helpNlTranslations }
        },
        es: {
          translation: esTranslations
        },
        de: {
          translation: deTranslations
        }
      },
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false
      }
    });
  
  // Try to load user's language preference from Supabase
  const tryLoadUserLanguage = async () => {
    try {
      // Get current session
      const { data: sessionData } = await supabase.auth.getSession();
      const user = sessionData.session?.user;
      
      if (user) {
        // Get user profile settings
        const { data, error } = await supabase
          .from('profiles')
          .select('language')
          .eq('id', user.id)
          .single();
        
        if (!error && data?.language) {
          i18n.changeLanguage(data.language);
        }
      }
    } catch (err) {
      console.error("Failed to load user language preference:", err);
    }
  };
  
  // Call the function but don't block initialization
  tryLoadUserLanguage();
  
  return i18n;
};

export default initI18n();